// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__i3lwH","tab":"Tabs_tab__3_Lr3","tabActive":"Tabs_tabActive__egtfd"};